/**
 * Whether the signed-in user belongs to a company (can use company-scoped UI).
 * Auth returns `company` as a name string; login also exposes `company_id` when available.
 */
export function userBelongsToCompany(user) {
  if (!user?.id) return false;
  return Boolean(user.company_id ?? user.company?.id ?? user.company);
}
